/**
* Service Hero JS
* -----------------------------------------------------------------------------
*
* All the JS for the Service Hero component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'service-hero',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.service-hero' ).each( function( key, val ) {
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top 75%',
            onRefresh: ( self ) => {
              if ( self.progress > 0 ) {
                setTimeout( function() {
                  $( val ).addClass( 'is-loaded' );
                }, 1000 );
              }
            },
            onEnter: ( {progress, direction, isActive} ) => {
              setTimeout( function() {
                $( val ).addClass( 'is-loaded' );
              }, 1000 );
            },
          },
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'service-hero', COMPONENT );
} )( app );
